export default {
    init() {
      
    },

    socketScrips(){
        function connect() {
            // var conn = new WebSocket('wss://exleasingcar.biz:8083');
            var host = window.location.host;
            var ending = host.includes(".com") ? '.com' : '.dev';
            var subdomain = host.split('.')[0];
            // var conn = new WebSocket('wss://'+subdomain+'-api.adamauction'+ending+'/ws');
            var conn = new WebSocket('wss://tradercars-api.adamauction.com/ws');
            conn.onopen = function(e){ openListener(e); };
            conn.onmessage = function(e){ messageListener(e); };
            conn.onclose = function(e){ closeListener(e); };

            function heartbeat() {
                if(conn.readyState == 3){
                    conn.close();
                }
                else{
                    conn.send('{"ping":"pong"}');
                    console.log('ping');
                    setTimeout(heartbeat, 10000);
                }
            }

            function closeListener(e) {
                setTimeout(function() {
                    conn = new WebSocket('wss://'+subdomain+'-api.adamauction'+ending+'/ws');
                    conn.onopen = function(e){ openListener(e); };
                    conn.onmessage = function(e){ messageListener(e); };
                    conn.onclose = function(e){ closeListener(e); };
                }, 1000);
            };

            function openListener(e) {
                console.log("Connection established!");
                heartbeat();
            };

            // conn.onclose = function(e) {
            //     conn = new WebSocket('wss://'+subdomain+'-api.adamauction.dev/ws');
            // };

            function messageListener(e) {

                var amountHolder = $(".current-amount-socketed");
                var bidInputs = $(".bid-input-socketed");
                var currentUserId = $("#current_user_id").html();
                
                var data = JSON.parse(e.data);
                if(data['amount'] !== null && typeof data['amount'] !== 'undefined'){

                    var amount = number_format(data['amount'], 0, '1', ' ');
                    if(data["bidsCount"]) $('.bid_count_'+data['lot_id']).html(data["bidsCount"]);

                    amountHolder.each(function (i, val) {
                        var lot_id = $(this).attr('lot_id');
                        if(lot_id == data['lot_id']){
                            $(this).html(amount);
                        } 
                    });

                    bidInputs.each(function (i, input) {
                        var lot_id = $(this).attr('lot_id');
                        var step = $(this).attr('step');

                        if(data['winning_user'] == currentUserId){
                            if(lot_id == data['lot_id']){
                                $(this).closest('.product-card ').addClass('winning');
                            } 
                        }
                        else{
                            if(lot_id == data['lot_id']){
                                $(this).closest('.product-card ').removeClass('winning');
                            } 
                        }

                        if(lot_id == data['lot_id']){
                            $(this).val(parseInt(data['amount'])+parseInt(step)).trigger('input');
                            $('.quick-bid1 .quick-value').html(parseInt(parseInt(data['amount'])+parseInt(step)));
                            $('.quick-bid2 .quick-value').html(+parseInt(parseInt(data['amount'])+parseInt(step*2)));
                            $('.quick-bid3 .quick-value').html(+parseInt(parseInt(data['amount'])+parseInt(step*3)));
                        } 
                    });
                }
                
            };

            // document.addEventListener("visibilitychange", function() {
            //     if (document.visibilityState === 'visible') {
            //         window.location.reload();
            //     }
            // });

            $(document).on('click', '.quick-bid', function (e) {
                e.preventDefault();
                let loader = $('.loader-holder');
                loader.show();
    
                var bid = $(this).find('.quick-value').html();
                
    
                $.ajax({
                    type: 'POST',
                    url: '/make-bid/' + $(this).attr("auction") + '/' + $(this).attr("lot"),
                    data: {
                        'bid': bid
                    },
                    success: function (response) {
                        loader.fadeOut(300);
                        conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+', "winning_user": '+response["winning_user"]+', "bidsCount": '+response["bidsCount"]+'}');
                        // car.removeClass('losing winning').addClass(response.bid.bidStatus);
                        // $('.loader-holder').css('display','none');
                    }
                });
            });
    
            $(document).on('submit', '#bid-form', function (e) {
                e.preventDefault();
                var url = $(this).attr('action');
                var dataString = $("#bid-form").serialize();

                $('.bid-approve-popup').fadeIn().removeClass('d-none');

                $('.pop-up-close').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');
                });

                $('.close-pop').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');

                    let loader = $('.loader-holder');
                    loader.show();
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: dataString,
                        success: function(response) {
                            loader.fadeOut(300);

                            if(response["error"]==0){
                                conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+', "winning_user": '+response["winning_user"]+', "bidsCount": '+response["bidsCount"]+'}');
                            } else{
                                alert(response["error_txt"]);
                            }

                            // conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+'}');
                            // console.log('working: '+msg);
                        },
                        error: function(msg) {
                            console.log('not working '+msg);
                        }
                    });
                });
            });

            let submitForm = false;
            $(document).on('submit', '#buynow-form', function (e) {
                let formToSubmit = $(this);
                if(!submitForm){
                    e.preventDefault();
                    let form = $(this);
                    $('.bid-approve-popup').fadeIn().removeClass('d-none');

                    $('.pop-up-close').click(function() {
                        $('.bid-approve-popup').fadeOut();
                        $('.pop-up-close').off('click');
                        $('.close-pop').off('click');
                    });

                    $('.close-pop').click(function() {
                        $('.bid-approve-popup').fadeOut();
                        $('.pop-up-close').off('click');
                        $('.close-pop').off('click');

                        submitForm = true;
                        formToSubmit.submit();
                    });
                }
            });

            $('.make-user-bid').on('click', function (e) {
                var currentUserId = $("#current_user_id").html();
                let input = $(this).parent().find('.user-bid-input');
                let car = input.parent().parent().parent().parent().parent();
                let auction = input.attr('data-auction');
                let lot = input.attr('data-lot');
                let bid = parseInt(input.val());
                let step = parseInt(input.attr('step'));

                if(bid>0 && auction>0 && lot>0 && input[0].checkValidity() == true) {
                    e.preventDefault();
                    $('.bid-approve-popup').fadeIn().removeClass('d-none');

                    $('.pop-up-close').click(function() {
                        $('.bid-approve-popup').fadeOut();
                        $('.pop-up-close').off('click');
                        $('.close-pop').off('click');
                    });

                    $('.close-pop').click(function() {
                        $('.bid-approve-popup').fadeOut();
                        $('.pop-up-close').off('click');
                        $('.close-pop').off('click');
                        $('.loader-holder').css('display','block');
                        $.ajax({
                            type: 'POST',
                            url: '/make-bid/' + auction + '/' + lot,
                            data: {
                                'bid': bid
                            },
                            success: function (response) {
                                if(response["error"]==0){
                                    conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+', "winning_user": '+response["winning_user"]+', "bidsCount": '+response["bidsCount"]+'}');
                                } else{
                                    alert(response["error_txt"]);
                                }
                                // car.removeClass('losing winning').addClass(response.bid.bidStatus);
                                $('.loader-holder').css('display','none');
                            }
                        });
                    });
                }
            });
    
    
            function number_format(number, decimals, dec_point, thousands_sep) {
                number = number.toFixed(decimals);
        
                var nstr = number.toString();
                nstr += '';
                var x = nstr.split('.');
                var x1 = x[0];
                var x2 = x.length > 1 ? dec_point + x[1] : '';
                var rgx = /(\d+)(\d{3})/;
        
                while (rgx.test(x1))
                    x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');
        
                return x1 + x2;
            }
            
    
            // $(document).on('click', '#bid', function (e) {
            //     console.log('click');
            //     conn.send('bidas');
            // });
        }
        // connect();


        $(document).on('click', '.quick-bid', function (e) {
            e.preventDefault();
            let loader = $('.loader-holder');
            loader.show();

            var bid = $(this).find('.quick-value').html();

            $.ajax({
                type: 'POST',
                url: '/make-bid/' + $(this).attr("auction") + '/' + $(this).attr("lot"),
                data: {
                    'bid': bid
                },
                success: function (response) {
                    loader.fadeOut(300);
                }
            });
        });

        $(document).on('submit', '#bid-form', function (e) {
            e.preventDefault();
            var url = $(this).attr('action');
            var dataString = $("#bid-form").serialize();

            $('.bid-approve-popup').fadeIn().removeClass('d-none');

            $('.pop-up-close').click(function() {
                $('.bid-approve-popup').fadeOut();
                $('.pop-up-close').off('click');
                $('.close-pop').off('click');
            });

            $('.close-pop').click(function() {
                $('.bid-approve-popup').fadeOut();
                $('.pop-up-close').off('click');
                $('.close-pop').off('click');

                let loader = $('.loader-holder');
                loader.show();
                $.ajax({
                    type: "POST",
                    url: url,
                    data: dataString,
                    success: function(response) {
                        loader.fadeOut(300);

                        if(response["error"]==0){
                        } else{
                            alert(response["error_txt"]);
                        }

                        // conn.send('{"amount" : '+response["amount"]+', "lot_id": '+response["lot_id"]+'}');
                        // console.log('working: '+msg);
                    },
                    error: function(msg) {
                        console.log('not working '+msg);
                    }
                });
            });
        });

        let submitForm = false;
        $(document).on('submit', '#buynow-form', function (e) {
            let formToSubmit = $(this);
            if(!submitForm){
                e.preventDefault();
                let form = $(this);
                $('.bid-approve-popup').fadeIn().removeClass('d-none');

                $('.pop-up-close').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');
                });

                $('.close-pop').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');

                    submitForm = true;
                    formToSubmit.submit();
                });
            }
        });

        $('.make-user-bid').on('click', function (e) {
            var currentUserId = $("#current_user_id").html();
            let input = $(this).parent().find('.user-bid-input');
            let car = input.parent().parent().parent().parent().parent();
            let auction = input.attr('data-auction');
            let lot = input.attr('data-lot');
            let bid = parseInt(input.val());
            let step = parseInt(input.attr('step'));

            if(bid>0 && auction>0 && lot>0 && input[0].checkValidity() == true) {
                e.preventDefault();
                $('.bid-approve-popup').fadeIn().removeClass('d-none');

                $('.pop-up-close').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');
                });

                $('.close-pop').click(function() {
                    $('.bid-approve-popup').fadeOut();
                    $('.pop-up-close').off('click');
                    $('.close-pop').off('click');
                    $('.loader-holder').css('display','block');
                    $.ajax({
                        type: 'POST',
                        url: '/make-bid/' + auction + '/' + lot,
                        data: {
                            'bid': bid
                        },
                        success: function (response) {
                            if(response["error"]==0){
                            } else{
                                alert(response["error_txt"]);
                            }
                            // car.removeClass('losing winning').addClass(response.bid.bidStatus);
                            $('.loader-holder').css('display','none');
                        }
                    });
                });
            }
        });
    }
}

   
